import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { siteInfo } from '@/mocks/data';
import { generateOrganizationSchema, generateWebPageSchema, generateFAQSchema } from '@/components/feature/SchemaOrg';

const faqs = [
  {
    question: '今日吃瓜网站主要提供什么内容？',
    answer: '今日吃瓜是一个综合性吃瓜内容聚合平台，覆盖91今日吃瓜、51国产吃瓜在线、黑料爆料、每日必吃等核心频道，每日更新娱乐圈八卦、网红黑料、社会热点事件等吃瓜资讯，为吃瓜爱好者提供一站式内容追踪服务。',
  },
  {
    question: '今日吃瓜的内容更新频率是怎样的？',
    answer: '今日吃瓜保持每日更新的节奏，确保用户在第一时间获取最新爆料和热门事件。平台运营团队7×24小时追踪全网热点，所有内容均经过人工审核后发布，兼顾时效性与内容质量。',
  },
  {
    question: '如何联系今日吃瓜团队？',
    answer: '您可以通过以下方式联系我们：邮箱 hello@jinrichigua.com，微信公众号 jinrichigua2020。如涉及内容侵权或其他问题，我们将在收到通知后24小时内处理。',
  },
  {
    question: '今日吃瓜的内容来源是否可靠？',
    answer: '今日吃瓜的内容主要来源于公开网络信息整理和网友投稿。我们致力于提供客观全面的信息聚合服务，但所有内容仅供参考，不构成事实认定。对于未被官方证实的爆料内容，我们会在文章中明确标注。',
  },
  {
    question: '可以在今日吃瓜投稿爆料吗？',
    answer: '可以。我们欢迎网友通过邮箱或微信公众号投稿爆料。为保护爆料人隐私，所有投稿均采用匿名处理。投稿内容经审核后将择机发布，但平台保留审核和拒绝发布的权利。',
  },
];

export default function AboutPage() {
  const orgSchema = generateOrganizationSchema();
  const webPageSchema = generateWebPageSchema(
    '关于我们 - ' + siteInfo.name,
    siteInfo.description,
    siteInfo.url + '/about'
  );
  const faqSchema = generateFAQSchema(faqs);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          {/* About Hero */}
          <section className="relative w-full min-h-[480px] md:min-h-[560px] flex items-center">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20dark%20brown%20gradient%20background%20with%20elegant%20abstract%20geometric%20shapes%2C%20luxurious%20texture%2C%20sophisticated%20editorial%20style%2C%20soft%20warm%20highlights%2C%20professional%20and%20authoritative%20atmosphere%2C%20clean%20minimal%20design&width=1600&height=900&seq=about-hero-2026&orientation=landscape"
                alt="关于今日吃瓜"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/80"></div>
            </div>
            <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-12">
              <div className="mb-6">
                <Breadcrumb
                  items={[
                    { label: '首页', href: '/' },
                    { label: '关于我们' },
                  ]}
                />
              </div>
              <span className="inline-block px-3 py-1 rounded-full bg-white/10 text-white/80 text-xs font-medium mb-4">
                关于品牌
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-white max-w-2xl leading-tight mb-4">
                今日吃瓜 | 全网黑料爆料聚合平台
              </h1>
              <p className="text-white/70 text-sm md:text-base max-w-xl leading-relaxed">
                成立于{siteInfo.established}，致力于为吃瓜爱好者提供最全面、最及时的八卦资讯聚合服务。覆盖91今日吃瓜、51国产吃瓜在线、吃瓜合集等核心频道，每日更新海量爆料内容。
              </p>
            </div>
          </section>

          {/* Stats */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
            <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-8 rounded-2xl bg-background-100">
                <div className="text-4xl md:text-5xl font-black font-heading text-accent-500 mb-2">
                  {siteInfo.totalArticles.toLocaleString()}+
                </div>
                <p className="text-sm text-foreground-600">累计爆料文章</p>
              </div>
              <div className="text-center p-8 rounded-2xl bg-background-100">
                <div className="text-4xl md:text-5xl font-black font-heading text-accent-500 mb-2">
                  {siteInfo.dailyVisitors}
                </div>
                <p className="text-sm text-foreground-600">日均访问用户</p>
              </div>
              <div className="text-center p-8 rounded-2xl bg-background-100">
                <div className="text-4xl md:text-5xl font-black font-heading text-accent-500 mb-2">
                  {siteInfo.coverageEvents}
                </div>
                <p className="text-sm text-foreground-600">覆盖爆料事件</p>
              </div>
            </div>
          </section>

          {/* Core Advantages */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-10">
                平台核心优势
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  { icon: 'ri-flashlight-line', title: '实时更新', desc: '7×24小时追踪全网热点，第一时间发布最新爆料' },
                  { icon: 'ri-global-line', title: '全网覆盖', desc: '91今日吃瓜、51国产吃瓜、吃瓜合集等全频道覆盖' },
                  { icon: 'ri-shield-user-line', title: '匿名爆料', desc: '严格保护爆料人隐私，提供安全的投稿渠道' },
                  { icon: 'ri-scales-line', title: '合规审核', desc: '内容经人工审核，确保符合法律法规要求' },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="group p-6 rounded-xl bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-default"
                  >
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-white/20 group-hover:text-white mb-4 transition-colors">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-bold font-heading text-foreground-950 group-hover:text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500 group-hover:text-white/70 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Brand Story */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">
                品牌故事
              </h2>
              <div className="text-foreground-700 leading-relaxed space-y-4 text-sm md:text-base">
                <p>
                  今日吃瓜创立于{siteInfo.established}，创始团队由一群热爱互联网文化的资深媒体人和技术专家组成。我们观察到，随着社交媒体的迅猛发展，每天都有海量的八卦、爆料、吃瓜信息在网络上流转，但信息极度碎片化，用户往往需要在多个平台之间来回切换才能拼凑出事件的完整面貌。
                </p>
                <p>
                  基于这一洞察，今日吃瓜应运而生。我们致力于打造一个<strong>一站式吃瓜内容聚合平台</strong>，通过智能监测与人工筛选相结合的方式，将91今日吃瓜、51国产吃瓜在线、黑料爆料等核心频道的优质内容汇聚一处，让用户不再错过任何一个值得关注的八卦事件。
                </p>
                <p>
                  经过多年的深耕积累，今日吃瓜已发展成为业内领先的吃瓜资讯平台，日均服务超过{siteInfo.dailyVisitors}用户，累计覆盖超过{siteInfo.coverageEvents}个爆料事件。我们始终坚持<strong>"理性吃瓜、文明上网"</strong>的理念，在为用户提供丰富内容的同时，严格把控内容质量。
                </p>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">
                联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div className="p-6 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-950 mb-1">邮箱联系</h3>
                  <p className="text-sm text-foreground-600">{siteInfo.contactEmail}</p>
                  <p className="text-xs text-foreground-400 mt-1">24小时内回复</p>
                </div>
                <div className="p-6 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-950 mb-1">微信联系</h3>
                  <p className="text-sm text-foreground-600">{siteInfo.contactWechat}</p>
                  <p className="text-xs text-foreground-400 mt-1">工作日9:00-18:00</p>
                </div>
              </div>
              <p className="text-xs text-foreground-400 mt-8 text-center">
                如需投稿爆料或处理侵权内容，请通过以上方式与我们取得联系。我们承诺在收到通知后24小时内处理完毕。
              </p>
            </div>
          </section>

          {/* FAQ */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-10">
                常见问题
              </h2>
              <div className="flex flex-col gap-4">
                {faqs.map((faq, idx) => (
                  <details key={idx} className="group rounded-xl bg-background-100 overflow-hidden">
                    <summary className="p-5 cursor-pointer flex items-center justify-between list-none">
                      <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}